// Vendor libraries
import { createReducer, on } from '@ngrx/store';
import cloneDeep from 'lodash.clonedeep';
// NgRx actions
import { resetAllCustomPdfReportItems } from '../actions';
import { resetSelectedReport, setReportTitle, setSelectedReport, updateSelectedReportWizardStep, } from './selected-report.actions';
export const selectedReport = createReducer({}, on(setSelectedReport, (state, action) => {
    if (action.reportData === undefined) {
        return {};
    }
    return action.reportData;
}), on(resetSelectedReport, () => {
    return {};
}), on(resetAllCustomPdfReportItems, () => {
    return {};
}), on(updateSelectedReportWizardStep, (state, action) => {
    const newState = cloneDeep(state);
    newState.wizard_steps = state.wizard_steps.map((step) => {
        // if the step has different name or modules, then it is not the step we are looking for
        if (step.eventName !== action.newStep.eventName)
            return step;
        if (step.modules?.length !== action.newStep.modules?.length)
            return step;
        if (step.modules !== undefined) {
            const equalModules = step.modules.every((originalModule, index) => {
                const newModule = action.newStep.modules?.[index];
                if (newModule === undefined)
                    return false;
                return originalModule.id === newModule.id && originalModule.module_type === newModule.module_type;
            });
            if (!equalModules)
                return step;
        }
        // if the step has the same name and modules, then this is the step we were looking to replace
        return action.newStep;
    });
    return newState;
}));
export const reportTitle = createReducer('', on(setReportTitle, (state, action) => action.title), on(resetAllCustomPdfReportItems, () => ''));
